import React, { useState, useEffect } from 'react';
import API from '../../services/api'; // Aapka exact API import
import DocumentReportsPage from './DocumentReportsPage';

const ETOPanel = () => {
    const [activeTab, setActiveTab] = useState('operations');
    const [stats, setStats] = useState({ total_bikes: 0, documents_received: 0, documents_pending: 0, documents_issued: 0 });
    
    // Single Receiving States
    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [selectedBike, setSelectedBike] = useState(null);
    const [singleForm, setSingleForm] = useState({ document_type: 'File', bike_ref_no: '', physical_location: '', received_by: '', remarks: '' });

    // Bulk Receiving States
    const [lotInput, setLotInput] = useState('');
    const [lotBikes, setLotBikes] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [bulkForm, setBulkForm] = useState({ document_type: 'File', received_by: '', remarks: '' });

    // Issuance States
    const [issueForm, setIssueForm] = useState({ inventory_stock_id: '', issued_type: 'Physical Handover', dispatch_id: '', issued_to: '', remarks: '' });

    useEffect(() => {
        fetchStats();
    }, []);

    const fetchStats = async () => {
        try {
            const res = await API.get('/documents/dashboard-stats');
            if (res.data.success) setStats(res.data.data);
        } catch (err) {
            console.error("Error fetching stats:", err);
        }
    };

    const handleSearchBike = async () => {
        if (!searchQuery) return alert('Please enter engine, chassis, or stock ID');
        try {
            const res = await API.get(`/documents/search-bike?query=${searchQuery}`);
            if (res.data.success) setSearchResults(res.data.data);
        } catch (err) { console.error(err); }
    };

    const handleSingleReceiveSubmit = async (e) => {
        e.preventDefault();
        if (!selectedBike) return alert('Please select a bike first!');
        try {
            const res = await API.post('/documents/receive-single', {
                inventory_stock_id: selectedBike.inventory_stock_id,
                ...singleForm
            });
            alert(res.data.message);
            if (res.data.success) {
                setSelectedBike(null); setSearchQuery(''); setSearchResults([]);
                fetchStats();
            }
        } catch (err) { console.error(err); }
    };

    const handleLoadLot = async () => {
        if (!lotInput) return alert('Enter Lot or DO Number');
        try {
            const res = await API.get(`/documents/load-lot/${lotInput}`);
            if (res.data.success) {
                setLotBikes(res.data.data.map(b => ({ ...b, checked: true })));
                setSelectAll(true);
            }
        } catch (err) { console.error(err); }
    };

    const handleBulkReceiveSubmit = async (e) => {
        e.preventDefault();
        const selectedIds = lotBikes.filter(b => b.checked).map(b => b.inventory_stock_id);
        if (selectedIds.length === 0) return alert('No bikes selected!');
        try {
            const res = await API.post('/documents/receive-bulk', {
                inventory_stock_ids: selectedIds,
                ...bulkForm
            });
            alert(res.data.message);
            if (res.data.success) {
                setLotBikes([]); setLotInput('');
                fetchStats();
            }
        } catch (err) { console.error(err); }
    };

    const handleIssueSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await API.post('/documents/issue-document', issueForm);
            alert(res.data.message);
            if (res.data.success) {
                setIssueForm({ inventory_stock_id: '', issued_type: 'Physical Handover', dispatch_id: '', issued_to: '', remarks: '' });
                fetchStats();
            }
        } catch (err) { console.error(err); }
    };

    const completionPercentage = stats.total_bikes > 0 ? ((stats.documents_received / stats.total_bikes) * 100).toFixed(1) : 0;

    return (
        <div style={containerStyle}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', borderBottom: '2px solid #e2e8f0', paddingBottom: '10px' }}>
                <h2>📑 Doc Department</h2>
                <div>
                    <button onClick={() => setActiveTab('operations')} style={navTabBtn(activeTab === 'operations')}>Operations Panel</button>
                    <button onClick={() => setActiveTab('reports')} style={navTabBtn(activeTab === 'reports')}>📊 Detailed Reports</button>
                </div>
            </div>

            {activeTab === 'operations' ? (
                <div>
                    <div style={statsGridStyle}>
                        <div style={{ ...cardStyle, background: '#e0f2fe' }}><h5>Total Bikes</h5><h3>{stats.total_bikes}</h3></div>
                        <div style={{ ...cardStyle, background: '#dcfce7' }}><h5>Documents Received</h5><h3>{stats.documents_received}</h3></div>
                        <div style={{ ...cardStyle, background: '#fee2e2' }}><h5>Documents Pending</h5><h3>{stats.documents_pending}</h3></div>
                        <div style={{ ...cardStyle, background: '#fef3c7' }}><h5>Documents Issued</h5><h3>{stats.documents_issued}</h3></div>
                        <div style={{ ...cardStyle, background: '#f3e8ff', textAlign: 'center' }}>
                            <h5>Completion</h5><h3 style={{ color: '#7c3aed' }}>{completionPercentage}%</h3>
                        </div>
                    </div>

                    <div style={gridTwoCol}>
                        <div style={boxStyle}>
                            <h4>A. Individual Bike Document Receiving</h4>
                            <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
                                <input type="text" placeholder="Engine, Chassis, Stock ID..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} style={inputStyle} />
                                <button onClick={handleSearchBike} style={btnPrimary}>Search</button>
                            </div>
                            {searchResults.length > 0 && (
                                <div style={{ maxHeight: '120px', overflowY: 'auto', border: '1px solid #cbd5e1', padding: '5px', marginBottom: '10px' }}>
                                    {searchResults.map(bike => (
                                        <div key={bike.inventory_stock_id} onClick={() => setSelectedBike(bike)} style={{ padding: '6px', cursor: 'pointer', background: selectedBike?.inventory_stock_id === bike.inventory_stock_id ? '#bae6fd' : '#fff', borderBottom: '1px solid #f1f5f9' }}>
                                            <b>Model:</b> {bike.model_name} | <b>Engine:</b> {bike.engine_number}
                                        </div>
                                    ))}
                                </div>
                            )}
                            <form onSubmit={handleSingleReceiveSubmit}>
                                <div style={formGroup}>
                                    <label>Document Type:</label>
                                    <select value={singleForm.document_type} onChange={(e) => setSingleForm({...singleForm, document_type: e.target.value})} style={inputStyle}>
                                        <option value="File">File</option><option value="Voucher">Voucher</option>
                                    </select>
                                </div>
                                <div style={formGroup}><label>Bike Ref No:</label><input type="text" value={singleForm.bike_ref_no} onChange={(e) => setSingleForm({...singleForm, bike_ref_no: e.target.value})} style={inputStyle} /></div>
                                <div style={formGroup}><label>Physical Location:</label><input type="text" value={singleForm.physical_location} onChange={(e) => setSingleForm({...singleForm, physical_location: e.target.value})} style={inputStyle} /></div>
                                <div style={formGroup}><label>Received By:</label><input type="text" required value={singleForm.received_by} onChange={(e) => setSingleForm({...singleForm, received_by: e.target.value})} style={inputStyle} /></div>
                                <div style={formGroup}><label>Remarks:</label><textarea value={singleForm.remarks} onChange={(e) => setSingleForm({...singleForm, remarks: e.target.value})} style={inputStyle}></textarea></div>
                                <button type="submit" style={{ ...btnPrimary, width: '100%' }}>Receive Document</button>
                            </form>
                        </div>

                        <div style={boxStyle}>
                            <h4>B. Bulk DO / Lot Receiving</h4>
                            <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
                                <input type="text" placeholder="Enter Lot / DO No" value={lotInput} onChange={(e) => setLotInput(e.target.value)} style={inputStyle} />
                                <button onClick={handleLoadLot} style={btnSecondary}>Load Bikes</button>
                            </div>
                            {lotBikes.length > 0 && (
                                <div style={{ maxHeight: '130px', overflowY: 'auto', border: '1px solid #cbd5e1', padding: '8px', marginBottom: '10px' }}>
                                    <div><input type="checkbox" checked={selectAll} onChange={(e) => { setSelectAll(e.target.checked); setLotBikes(lotBikes.map(b => ({ ...b, checked: e.target.checked }))); }} /> <b>Select All ({lotBikes.length})</b></div>
                                    <hr style={{margin: '5px 0'}}/>
                                    {lotBikes.map(b => (
                                        <div key={b.inventory_stock_id}>
                                            <input type="checkbox" checked={b.checked} onChange={() => setLotBikes(lotBikes.map(x => x.inventory_stock_id === b.inventory_stock_id ? { ...x, checked: !x.checked } : x))} /> Stock ID: {b.inventory_stock_id} | Engine: {b.engine_number}
                                        </div>
                                    ))}
                                </div>
                            )}
                            <form onSubmit={handleBulkReceiveSubmit}>
                                <div style={formGroup}>
                                    <label>Document Type:</label>
                                    <select value={bulkForm.document_type} onChange={(e) => setBulkForm({...bulkForm, document_type: e.target.value})} style={inputStyle}>
                                        <option value="File">File</option><option value="Voucher">Voucher</option>
                                    </select>
                                </div>
                                <div style={formGroup}><label>Received By:</label><input type="text" required value={bulkForm.received_by} onChange={(e) => setBulkForm({...bulkForm, received_by: e.target.value})} style={inputStyle} /></div>
                                <div style={formGroup}><label>Remarks:</label><input type="text" value={bulkForm.remarks} onChange={(e) => setBulkForm({...bulkForm, remarks: e.target.value})} style={inputStyle} /></div>
                                <button type="submit" style={{ ...btnSuccess, width: '100%' }}>Bulk Receive Selected</button>
                            </form>
                        </div>
                    </div>

                    <div style={boxStyle}>
                        <h4>C. Document Issuance Section</h4>
                        <form onSubmit={handleIssueSubmit} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                            <div style={formGroup}><label>Stock ID to Issue:</label><input type="text" required placeholder="Enter Inventory Stock ID" value={issueForm.inventory_stock_id} onChange={(e) => setIssueForm({...issueForm, inventory_stock_id: e.target.value})} style={inputStyle} /></div>
                            <div style={formGroup}>
                                <label>Issued Type:</label>
                                <select value={issueForm.issued_type} onChange={(e) => setIssueForm({...issueForm, issued_type: e.target.value})} style={inputStyle}>
                                    <option value="Physical Handover">Physical Handover</option><option value="Dispatch">Dispatch</option>
                                </select>
                            </div>
                            <div style={formGroup}><label>Dispatch ID:</label><input type="text" value={issueForm.dispatch_id} onChange={(e) => setIssueForm({...issueForm, dispatch_id: e.target.value})} style={inputStyle} /></div>
                            <div style={formGroup}><label>Issued To:</label><input type="text" required value={issueForm.issued_to} onChange={(e) => setIssueForm({...issueForm, issued_to: e.target.value})} style={inputStyle} /></div>
                            <div style={{ gridColumn: 'span 2', ...formGroup }}><label>Remarks:</label><input type="text" value={issueForm.remarks} onChange={(e) => setIssueForm({...issueForm, remarks: e.target.value})} style={inputStyle} /></div>
                            <div style={{ gridColumn: 'span 2' }}><button type="submit" style={{ ...btnWarning, width: '100%' }}>Issue Document</button></div>
                        </form>
                    </div>
                </div>
            ) : (
                <DocumentReportsPage />
            )}
        </div>
    );
};

// Styles
const containerStyle = { padding: '20px', background: '#f8fafc', borderRadius: '12px', fontFamily: 'Arial, sans-serif' };
const statsGridStyle = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '15px', marginBottom: '20px' };
const cardStyle = { padding: '15px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' };
const gridTwoCol = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px' };
const boxStyle = { background: '#ffffff', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 6px rgba(0,0,0,0.05)', marginBottom: '20px' };
const formGroup = { marginBottom: '10px' };
const inputStyle = { width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #cbd5e1' };
const btnPrimary = { background: '#0284c7', color: '#fff', border: 'none', padding: '8px 15px', borderRadius: '4px', cursor: 'pointer' };
const btnSecondary = { background: '#475569', color: '#fff', border: 'none', padding: '8px 15px', borderRadius: '4px', cursor: 'pointer' };
const btnSuccess = { background: '#16a34a', color: '#fff', border: 'none', padding: '8px 15px', borderRadius: '4px', cursor: 'pointer' };
const btnWarning = { background: '#d97706', color: '#fff', border: 'none', padding: '8px 15px', borderRadius: '4px', cursor: 'pointer' };
const navTabBtn = (isActive) => ({ padding: '10px 20px', marginLeft: '10px', background: isActive ? '#0f172a' : '#e2e8f0', color: isActive ? '#fff' : '#000', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' });

export default ETOPanel;